import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { NewBannerComponent } from '@app/refactoringComponents/new-banner/new-banner.component';
import { HeaderComponent } from '@app/shared/components/header/header.component';
import { FooterComponent } from '@app/shared/components/footer/footer.component';



// import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';
// import { BannerAppComponent } from "../../../components/banner-app/banner-app.component";

@Component({
  selector: 'error-500',
  standalone: true,
 // imports: [FooterAppComponent, BannerAppComponent],
 //imports: [HeaderComponent],
   imports: [
    
   HeaderComponent,
   FooterComponent
 
     
   ],
  templateUrl: './error-500.component.html',
  styleUrl: './error-500.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error500Component implements OnInit {

  ngOnInit(): void { }


  volverInicio(): void {
    window.location.href = "https://www.sura.co/";
  }
}
